import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="categories--admin--events--print-button"
export default class extends Controller {
  static targets = ["printButton"];

  disablePrintButton(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;

    if (button.dataset.disabled === "true") {
      return;
    }

    const href = button.getAttribute("href");
    const method = button.getAttribute("data-method") || "post";

    button.dataset.disabled = "true";
    button.style.opacity = "0.5";
    button.style.cursor = "not-allowed";
    button.style.pointerEvents = "none";

    const originalContent = button.innerHTML;

    const isIconButton = button.querySelector("svg") !== null;

    if (isIconButton) {
      button.innerHTML = "...";
    } else {
      button.innerHTML = "Printing...";
    }

    this.makePrintRequest(href, method);

    setTimeout(() => {
      button.dataset.disabled = "false";
      button.style.opacity = "1";
      button.style.cursor = "pointer";
      button.style.pointerEvents = "auto";
      button.innerHTML = originalContent;
    }, 5000);
  }

  makePrintRequest(href, method) {
    const formData = new FormData();
    const csrfToken = document.querySelector("meta[name=\"csrf-token\"]")?.getAttribute("content");
    const headers = {
      "Accept": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    };

    if (csrfToken) {
      headers["X-CSRF-Token"] = csrfToken;
    }

    fetch(href, {
      method: method.toUpperCase(),
      headers,
      body: formData
    });
  }
}